<script setup lang="ts">
  import { Picture } from '@travelata-libs/ui-kit';
  import { CANVAS_HEIGHT, CANVAS_WIDTH, PARTNER_LOGOS, type PartnerLogo } from '../../config/logos';

  const toPercent = (value: number, total: number) => `${(value / total) * 100}%`;

  const logoStyle = (logo: PartnerLogo) => ({
    position: 'absolute' as const,
    left: toPercent(logo.left, CANVAS_WIDTH),
    top: toPercent(logo.top, CANVAS_HEIGHT),
    width: toPercent(logo.width, CANVAS_WIDTH),
    height: toPercent(logo.height, CANVAS_HEIGHT),
  });
</script>

<template>
  <div
    class="footer-payment-logos"
    data-testid="footer-payment-logos"
  >
  <component
    :is="logo.href ? 'a' : 'div'"
    v-for="logo in PARTNER_LOGOS"
    :key="logo.file"
    :href="logo.href"
    target="_blank">
    <Picture
      class="footer-payment-logos__item"
      :style="logoStyle(logo)"
      :path="`partner/logo/${logo.file}`"
      :alt="logo.name"
      :extensions="[]"
      :high-resolution="false"
      fit="contain"
    />
  </component>
  </div>
</template>

<style scoped lang="scss">
  .footer-payment-logos {
    height: 0;
    max-width: 243px;
    opacity: 0.4;
    padding-top: 56.379%;
    position: relative;
    width: 100%;
  }
</style>
